import { Controller } from "react-hook-form";
import React, { Fragment } from "react";
import Select from "react-select";
import { formatGroupLabel } from "root/ReactHookForm/ui/DropdownDataProviders";

export const CommonDropdown = ( { items, control, onChange, initialValue, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, validate } ) =>
{
    // Default readonly to false if not supplied
    const isReadOnly = readOnly === undefined ? false : readOnly ;

    const getReadOnlyContent = ( value, items ) =>
    {
        if ( value === null || value === undefined )
        {
            return null ;
        }

        if ( Array.isArray(value))
        {
            return value.reduce((acc, cur) =>
            {
                const entry = items.find ( element => +element.value === +cur.value );

                if ( entry === undefined )
                {
                    return acc === '' ? 'Unknown Relation ID ' + cur.value : acc + ', ' + 'Unknown Relation ID ' + cur.value ;
                }
                else
                {
                    return acc === '' ? entry.label : acc + ', ' + entry.label;
                }
            }, '');
        }
        else
        {
            let label = value.label ;

            if ( value.label === undefined )
            {
                const targetItem = items.find ( element => +element.value === +value.value );

                if ( targetItem !== undefined )
                {
                    label = targetItem.label ;
                }       
                else
                {
                    label = "Unknown ID " + value.value ;
                }
            }

            return label ;
        }
    }

    const getLabel = ( value ) =>
    {
        if ( value === null )
        {
            return null ;
        }

        let label = value.label ;

        if ( value.label === undefined )
        {
            const targetItem = items.filter ( (item) =>
            {
                if ( +(item.value) === +(value.value))
                {
                    return item ;
                }
            });

            if ( targetItem.length > 0 )
            {
                label = targetItem[0].label ;
            }
            else
            {
                label = "Unknown ID " + value.value ;
            }
        }

        return label ;
    }

    const initValue = (value, data) =>
    {
        let v = value ;

        let found = v === null || v === undefined ? null : data.find((element) =>
        {
            return element.value === v.value
        } );

        if ( Array.isArray(value))
        {
            const entry = value.map ((cur) =>
            {
                const entry = items.find ( element => +element.value === cur.value );

                if ( entry !== undefined )
                {
                    return {value: entry.value, label: entry.label}
                }
                else
                {
                    return { value: cur.value, label: 'Unknown Relation ID ' + cur.value }
                }
            })

            return entry ;
        }
        else if ( data === null || data === undefined || data.length === 0 || found === undefined)
        {
            return null ;
        }
        else if ( value === undefined || value === null || value.value === undefined || value.value === null )
        {
            return value ;
        }
        else if ( value.label !== undefined )
        {
            return value ;
        }
        else
        {
            v = { value: value.value, label: getLabel ( value ) }
        }

        return v ;
    }

    if (control === undefined)
    {
        return (
            <Fragment>
                <Select
                    placeholder={placeholder}
                    onChange={onChange}
                    defaultValue={initValue(initialValue)}
                    options={items}
                    isDisabled={readOnly}
                    isSearchable={isSearchable}
                    isClearable={isClearable}
                    isMulti={isMulti}
                    formatGroupLabel={formatGroupLabel}/>
            </Fragment>
        )
    }
    else
    {
        const customStyles = {
            // For the select it self, not the options of the select
            container: (styles, {isDisabled}) => {
                return {
                    ...styles,
                    borderRadius: '.3rem',
                    border: '.5px solid #ced4da'
                }
            },
            // For the options
            singleValue: (styles, {isDisabled}) => {
                const color = isDisabled ? 'rgb(66, 139, 205)' : 'inherit';
                return {
                    ...styles,
                    color: color,
                    marginLeft: '7px',
                    cursor: isDisabled ? 'not-allowed' : 'default',
                };
            },
        };

        return (
            <Controller
                control={control}
                name={name}
                rules={rules}
                validate={validate}
                render={({
                             field: {onChange, value, name, ref},
                             fieldState: {invalid, isTouched, isDirty, error},
                             formState
                         }) => (
                    <Fragment>
                    { readOnly !== true && <Select
                            placeholder={placeholder}
                            onChange={onChange}
                            defaultValue={initValue(value, items)}
                            options={items}
                            isSearchable={isSearchable}
                            isClearable={isClearable}
                            isMulti={isMulti}
                            formatGroupLabel={formatGroupLabel}/>}
                    { isReadOnly === true && <input className='form-control' readOnly={ readOnly } defaultValue={ getReadOnlyContent(value, items) }/> }
                    </Fragment>
                )}/>
        )
    }
}